{
	"title": "Attribution des logiciels open source",
	"backTitle": "Retour"
}
